import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { SUPPORT_EMAIL } from "@/lib/company";

export default function CookiePolicy() {
    useSeo({ title: "Cookie Policy | VendiDirect", description: "Informativa sui cookie utilizzati da vendidirect.it: tecnici, analitici e di preferenza. Gestisci il tuo consenso in ogni momento.", canonical: "/cookie" });
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="pt-32 pb-24 max-w-3xl mx-auto px-6 lg:px-12">
            <span className="label-eyebrow">Conformità GDPR + ePrivacy</span>
            <h1 className="font-serif text-4xl sm:text-5xl text-ink-50 leading-tight mt-3">Cookie Policy</h1>
            <p className="text-ink-400 text-sm mt-4">Ultimo aggiornamento: 21 maggio 2026</p>

            <div className="prose-sm mt-10 text-sm text-ink-100 leading-relaxed space-y-6">
                <p>Questa Cookie Policy descrive l'uso dei cookie e tecnologie simili sul sito vendidirect.it, ai sensi del <strong>Regolamento UE 2016/679 (GDPR)</strong>, della <strong>Direttiva ePrivacy 2002/58/CE</strong> e del provvedimento del Garante Privacy del 10 giugno 2021 (n. 231).</p>

                <h2 className="font-serif text-2xl text-ink-50 pt-4">Cosa sono i cookie</h2>
                <p>I cookie sono piccoli file di testo che i siti visitati memorizzano sul tuo dispositivo. Permettono al sito di funzionare correttamente e di ricordare le tue preferenze.</p>

                <h2 className="font-serif text-2xl text-ink-50 pt-4">Tipologie di cookie utilizzati</h2>

                <div className="border border-gold/30 p-5 bg-gold/5">
                    <h3 className="text-base text-gold font-medium mb-2">🍪 Cookie tecnici (sempre attivi)</h3>
                    <p className="text-xs">Necessari al funzionamento del sito. Non richiedono consenso (art. 122 D.Lgs. 196/2003).</p>
                    <table className="w-full text-xs mt-3">
                        <thead className="text-ink-400 border-b border-white/10"><tr><th className="text-left py-1">Nome</th><th className="text-left">Scopo</th><th className="text-left">Durata</th></tr></thead>
                        <tbody className="text-ink-100 divide-y divide-white/5">
                            <tr><td className="py-1 font-mono">session_token</td><td>Autenticazione utente</td><td>7 giorni</td></tr>
                            <tr><td className="py-1 font-mono">cookie_consent</td><td>Memorizza preferenze cookie</td><td>12 mesi</td></tr>
                            <tr><td className="py-1 font-mono">cf-* (Cloudflare)</td><td>Sicurezza e DDoS protection</td><td>30 minuti</td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="border border-white/10 p-5">
                    <h3 className="text-base text-ink-50 font-medium mb-2">📊 Cookie analitici (con consenso)</h3>
                    <p className="text-xs">Raccolgono dati aggregati e anonimi sull'uso del sito. Attivati solo dopo il tuo consenso esplicito.</p>
                    <ul className="text-xs mt-2 space-y-1">
                        <li>• Statistiche di navigazione (pagine viste, durata sessione)</li>
                        <li>• Conteggio visitatori (IP anonimizzato)</li>
                    </ul>
                </div>

                <div className="border border-white/10 p-5">
                    <h3 className="text-base text-ink-50 font-medium mb-2">🎯 Cookie di profilazione</h3>
                    <p className="text-xs">vendidirect.it <strong>NON utilizza</strong> cookie di profilazione, di terze parti pubblicitarie, social plugin o tracker comportamentali.</p>
                </div>

                <h2 className="font-serif text-2xl text-ink-50 pt-4">Come gestire i cookie</h2>
                <ul className="space-y-2 list-disc ml-6">
                    <li>Al primo accesso vedi un <strong>banner cookie</strong> dove puoi accettare, rifiutare o personalizzare</li>
                    <li>Puoi modificare in qualsiasi momento le tue preferenze cliccando "Impostazioni cookie" nel footer</li>
                    <li>Puoi bloccare tutti i cookie dalle impostazioni del browser (Chrome, Firefox, Safari, Edge)</li>
                    <li>Bloccare i cookie tecnici può rendere il sito non utilizzabile</li>
                </ul>

                <h2 className="font-serif text-2xl text-ink-50 pt-4">Contatti</h2>
                <p>Per domande sulla cookie policy scrivi a <a href={`mailto:${SUPPORT_EMAIL}`} className="text-gold hover:underline">{SUPPORT_EMAIL}</a>.</p>

                <p className="text-xs text-ink-400 pt-6 border-t border-white/10">Vedi anche: <Link to="/privacy" className="text-gold hover:underline">Informativa Privacy completa</Link> · <Link to="/termini" className="text-gold hover:underline">Termini di servizio</Link></p>
            </div>
        </div>
    );
}
